<template>
    <div>
        <v-select :multiple="false" :options="optionsProductos" :placeholder="'Selecciona '+placeholderm"
                  v-model="selectedProductos" @input="setCambio"></v-select>
    </div>
</template>

<script>
export default {
    name: "productosSimple",
    props:{
        placeholderm:String,
    },
    data(){
        return{
            selectedProductos:null,
            optionsProductos:[],
            marcas:[]
        }
    },
    mounted() {
        this.getProductos();
    },
    methods:{
        getProductos(){
            let $this = this;
            axios.post('/api/AdminCatalogos/productosSelectD',{marcas:this.marcas})
                .then(r => {
                        $this.optionsProductos = r.data.slice(1);
                        //console.log(r);
                    },
                    error => {$this.$toastMessage('error','Error: ' + error +' Por favor envia este error al área de soporte!',9000,'center');}
                );
        },
        setCambio(){
            this.$emit('cambioProducto');
        }
    }
}
</script>

<style scoped>

</style>
